import * as React from 'react';

import * as Styles from './InfoList.module.scss';

interface DataRowProps {
    label: string;
    value?: string;
}

const DataRow: React.FC<DataRowProps> = (props) => {
    const {label, value} = props;

    return (
        <tr>
            <td>{label}</td>
            <td>{value}</td>
        </tr>
    );
};

export const InfoList: React.FC<{data: DataRowProps[]}> = (props) => {
    const {data} = props;

    return (
        <table className={Styles['info-list']}>
            <tbody>
                {data.map((row) => <DataRow {...row} key={row.label}/>)}
            </tbody>
        </table>
    );
};
